
import React from "react";
import { Baby, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme/ThemeContext";

interface ChildrenEmptyStateProps {
  onAddChild: () => void;
}

export function ChildrenEmptyState({ onAddChild }: ChildrenEmptyStateProps) {
  const isLightTheme = false;

  return (
    <div className={`text-center p-12 rounded-lg transition-all duration-300 ${
      isLightTheme 
        ? "bg-gradient-to-b from-blue-50/80 to-white border border-blue-100/60 shadow-sm" 
        : "bg-slate-900"
    }`}>
      <div className={`mx-auto h-16 w-16 flex items-center justify-center rounded-full mb-6 ${
        isLightTheme 
          ? "bg-blue-100/70 text-blue-primary shadow-sm shadow-blue-100/30" 
          : "bg-slate-800 text-slate-500"
      }`}>
        <Baby className="h-8 w-8" />
      </div>
      
      <h3 className={`text-xl font-medium mb-3 ${
        isLightTheme ? "text-slate-800" : ""
      }`}>
        No children added yet
      </h3>
      
      <p className={`mb-8 max-w-md mx-auto ${
        isLightTheme ? "text-slate-600" : "text-slate-400"
      }`}>
        Add your first child to start tracking their sleep and feeding patterns
      </p>
      
      <Button 
        onClick={onAddChild}
        className={`px-6 py-5 h-auto shadow-md transition-all duration-300 ${
          isLightTheme 
            ? "bg-blue-primary hover:bg-blue-600 shadow-blue-200/50" 
            : "bg-purple-600 hover:bg-purple-700"
        }`}
      >
        <Plus className="h-5 w-5 mr-2" />
        <span className="text-base">Add Your First Child</span>
      </Button>
    </div>
  );
}
